import { PhoneNumberInput } from '@dxm/shared-components';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Stack } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

import { RegistrationStep } from '../../constants/steps.js';
import { useRegistration } from '../../contexts/RegistrationContext.js';
import { useSignInNavigation } from '../../hooks/use-sign-in-navigation.js';
import { userInfoSchema, type UserInfoFormData } from '../../validation/schemas.js';
import FormField from '../shared/FormField.js';
import { PrimaryButton, SmallText, StyledLink } from '../shared/index.js';

const UserInfo = () => {
  const { completeStep, setCurrentStep, setError, setUserInfo, userInfo } = useRegistration();
  const { navigateToSignIn } = useSignInNavigation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<UserInfoFormData>({
    resolver: yupResolver(userInfoSchema),
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: userInfo,
  });

  const onSubmit = (data: UserInfoFormData) => {
    setError(undefined);
    setUserInfo(data);
    completeStep(RegistrationStep.USER_INFO);
    setCurrentStep(RegistrationStep.ACCESS);
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3}>
          <FormField errors={errors} control={control} label="Email Address" name="email" />
          <FormField errors={errors} control={control} label="Name" name="name" />
          <Controller
            name="phoneNumber"
            control={control}
            render={({ field }) => (
              <PhoneNumberInput
                required
                allowMaskOverflow
                error={errors.phoneNumber?.message}
                name={field.name}
                value={field.value}
                onBlur={field.onBlur}
                onChange={field.onChange}
              />
            )}
          />
          <FormField errors={errors} control={control} label="Company Name" name="companyName" />
        </Stack>

        <PrimaryButton type="submit">Next</PrimaryButton>
      </form>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
        <StyledLink sx={{ cursor: 'pointer' }} onClick={navigateToSignIn}>
          Do you have an account? Log in
        </StyledLink>
      </Box>

      <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center', mt: 3 }}>
        <SmallText>By registering in you accept the</SmallText>
        <StyledLink
          href="https://login.digitalrealty.com/Account/TermsAndConditions"
          rel="noreferrer"
          sx={{ fontSize: 12 }}
          target="_blank"
        >
          Terms &amp; Conditions
        </StyledLink>
      </Box>
    </Box>
  );
};

export default UserInfo;
